"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreedingFarms = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var ResourceType_1 = require("../../ResourceType");
var SelectCard_1 = require("../../inputs/SelectCard");
var Resources_1 = require("../../Resources");
var CardRequirements_1 = require("../CardRequirements");
var Tags_1 = require("../Tags");
var BreedingFarms = (function (_super) {
    __extends(BreedingFarms, _super);
    function BreedingFarms() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.BREEDING_FARMS,
            cost: 16,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.ANIMAL, Tags_1.Tags.BUILDING],
            tr: { temperature: 1 },
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE).tag(Tags_1.Tags.ANIMAL); }),
            metadata: {
                cardNumber: 'Pf01',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 1 plant to add 1 animal to any card.', function (eb) {
                        eb.plants(1).startAction.animals(1);
                    });
                    b.br;
                    b.temperature(1);
                }),
                description: 'Requires 1 science tag and 1 animal tag. Raise the temperature 1 step.',
            },
        }) || this;
    }
    BreedingFarms.prototype.canAct = function (player) {
        return player.plants > 0 && player.getResourceCards(ResourceType_1.ResourceType.ANIMAL).length > 0;
    };
    BreedingFarms.prototype.action = function (player) {
        return new SelectCard_1.SelectCard('Select a card to gain an animal resource', 'Spend 1 plant', player.getResourceCards(ResourceType_1.ResourceType.ANIMAL), function (cards) {
            player.addResource(Resources_1.Resources.PLANTS, -1);
            player.addResourceTo(cards[0], { log: true });
            return undefined;
        });
    };
    BreedingFarms.prototype.play = function (player) {
        player.game.increaseTemperature(player, 1);
        return undefined;
    };
    return BreedingFarms;
}(Card_1.Card));
exports.BreedingFarms = BreedingFarms;
